import { useState } from 'react';
import { ApiError, apiSingle, setCsrfToken } from '../lib/api.js';
import type { Session } from '@captain-tasko/shared';
import { CaptainTaskoLogo } from '../components/CaptainTaskoLogo.js';

export function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState('owner@captain-tasko.local');
  const [password, setPassword] = useState('captain-tasko-dev-only');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      const data = await apiSingle<{ session: Session; csrfToken: string }>('/auth/login', {
        method: 'POST',
        body: { email, password },
      });
      setCsrfToken(data.csrfToken);
      onLoggedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Login failed');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit} aria-labelledby="login-title">
        {/* Brand mark + wordmark + tagline. Centered above the form so
            the first thing the user sees is "where am I and why." */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
          <CaptainTaskoLogo size={96} decorative={false} style={{ marginBottom: 12 }} />
          <h1 id="login-title" style={{ margin: 0, fontSize: 28, letterSpacing: '-0.01em' }}>
            Captain Tasko
          </h1>
          <p
            style={{
              margin: '6px 0 0',
              fontSize: 13,
              color: 'var(--text-muted)',
              textAlign: 'center',
              maxWidth: 320,
              lineHeight: 1.45,
              fontStyle: 'italic',
            }}
          >
            Built for teams who'd rather do the work than hunt for it.
          </p>
        </div>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <div className="toast toast--error" style={{ marginBottom: 12 }}>{error}</div>}
        <button className="btn btn--primary" type="submit" disabled={pending} style={{ width: '100%' }}>
          {pending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
